export default __webpack_public_path__ + "static/media/fb.d9072c1b.svg";